import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowDown.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...e, weights: a }));
r.displayName = "ArrowDownIcon";
const c = r;
export {
  c as ArrowDown,
  r as ArrowDownIcon
};
